module.exports = __webpack_public_path__ + "media/images/undraw/reserve/chat_bot-7a6246599ab298eaf826c3b8478699fd.png";